const IMPERSONATE_TOKEN_PARAM = 'impersonate-token';
export const IMPERSONATED_TOKEN_STORAGE_KEY = 'noddi-impersonated-token';

// Token is passed in the URL fragment (not the query string) so it is never sent to the
// server or leaked via the Referer header. The customer app strips it immediately on load.
export const buildImpersonateUrl = (appUrl: string, token: string) => {
  const url = new URL(appUrl);
  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
  hashParams.set(IMPERSONATE_TOKEN_PARAM, token);
  url.hash = hashParams.toString();
  return url.toString();
};

export const consumeImpersonateTokenFromUrl = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const url = new URL(window.location.href);
  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
  const token = hashParams.get(IMPERSONATE_TOKEN_PARAM);
  if (!token) {
    return;
  }
  localStorage.setItem(IMPERSONATED_TOKEN_STORAGE_KEY, token);
  hashParams.delete(IMPERSONATE_TOKEN_PARAM);
  url.hash = hashParams.toString();
  window.history.replaceState({}, '', url.toString());
};
